import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { buildAnswers, buildUserAnswerMessage } from '../utils';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderSingleImage } from '../../views/SingleImage';
import { renderSimpleButtonGroup } from '../../views/SimpleButtonGroup';

import RobotImagineSearchCriteriaPngPath from 'Images/me/pages/guest/proposals/new/robot_imagine_search_criteria.png'
import RobotImagineSearchCriteriaWebPPath from 'Images/me/pages/guest/proposals/new/robot_imagine_search_criteria.webp'

const SECTION_KEY_NAME = 'preferredSearchCriteria';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'preferredSearchCriteria';

export const preferredSearchCriteriaSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: BaseAnswerType[] = [
    { value: '口コミ・評判', balloonContents: '78%' },
    { value: '工事内容', balloonContents: '15%' },
    { value: 'サービス', balloonContents: '3%' },
    { value: 'こだわらない', balloonContents: '4%' },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '重視したい業者の絞り込み条件は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        重視したい項目はどちらですか？
      </>
    ),
  });

  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: RobotImagineSearchCriteriaPngPath,
      webp: RobotImagineSearchCriteriaWebPPath,
    },
    altText: '口コミ・評判、工事内容、サービス など',
    viewWidth: {
      pc: 454,
      mobile: 355,
    },
    imageRatio: { width: 454, height: 360 },
    delayTime: 1,
  });

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    enableHideAnimation: false,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
